module.exports = __webpack_public_path__ + "static/img/plate.faea287.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s34/pop/plate.png
// module id = Rgcw
// module chunks = 2